import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS, NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "../BenefitMaxSchedule/BenefitAltCopayConfig";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import { useRBAC } from "../../common_nextgen/hooks/RBACContext";


const screenInfo = {
  ADD: ["Benefit Maximum Step Alternate Copays", "RCBAC001"],
  CHANGE: ["Benefit Maximum Step Alternate Copays", "RCBAC001"],
};

const BenefitMaximumStepAlternateCopaysForm = ({ mode }) => {
  const location = useLocation();
  const { ALTERNATE_COPPAY_OVERRIDE, BENEFIT_MAX_STEP_SCHEDULE_SEARCH } =
    ROUTE_PATHS;
  
  const {writeAccess} = useRBAC();

  //const { state: stateVal } = location;
  const stateVal = location.state || [];
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  let {
    selectedPriceSchedules = [],
    previousScreen = BENEFIT_MAX_STEP_SCHEDULE_SEARCH,
    currentIndex: initialIndex = 0,
    scheduleName,
    paramsData,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const toast = useToast();
  const [bscDescription, setBscDescription] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const { axios_helper_no_header } = useAxios();

  const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params ,formData) => {
    showModal(lookupScreen, { params }, handleReceiveData,formData);
  };

  const handleBack = () => {
    if (currentIndex < selectedPriceSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/bacBenefitMaxAltCopay";
      verb = "POST";
      screenNumber = screenInfo.CHANGE[1];
    } else {
      url = "api/bacBenefitMaxAltCopay";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    

    if (JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)) {
     infoChanged = false;
    }
  }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
             toast.current.show({
               severity: "info",
               summary: "",
               detail: responseStatus.message,
               life: 3000,
             });
           } else {
             toast.current.show({
               severity: "success",
               summary: "",
               detail: responseStatus.message,
               life: 3000,
             });
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        currentState = {
          ...currentState,
          selectedPriceSchedules: [{ ...responseData }],
          currentIndex: 0,
        };
        navigateToPage(ROUTE_PATHS.BENEFIT_ALT_COPAY_FORM_EDIT, [
          ...previousState,
          currentState,
        ]);
      } else {
        setInitialFormData(responseData);
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const navigateWithFetchedData = () => {
    //  if (fetchedData && fetchedData.bmdScheduleCode) {
    navigateToPage(ALTERNATE_COPPAY_OVERRIDE, [
      ...previousState,
      { ...currentState, currentIndex },
      {
        selectedPriceSchedules: [initialFormData],
        currentIndex: 0,
        previousScreen: location.pathname,
        paramsData: {
          bscScheduleName: initialFormData.bscScheduleName,
          bscDescription: initialFormData.bscDescription,
          bsdStepNumber: initialFormData.bsdStepNumber,
          bmdScheduleCode: initialFormData.bmdScheduleCode,
          bmdDescription: initialFormData.bmdDescription,
        },
      },
    ]);
    //  }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";

      keyName.F7 = "Alt copay PSC Override";
      keyFunc.F7 = navigateWithFetchedData;
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, fetchedData, initialFormData]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const params = {
        bscScheduleName: scheduleName,
        bsdStepNumber: selectedPriceSchedules[currentIndex]?.bsdStepNumber,
      };
      const url = `api/bacBenefitMaxAltCopay/initialFormData/RCBAC001`;
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        {},
        params
      );
      setInitialFormData(responseData);
      setFetchedData(responseData);
      console.log("scdsc", responseData);

      // Check if bmdScheduleCode is present in the response
      if (responseData.bmdScheduleCode) {
        setCurrentMode(writeAccess ? PRICE_SCHEDULE_MODES.EDIT : PRICE_SCHEDULE_MODES.READ_ONLY);
      } else {
        setCurrentMode(PRICE_SCHEDULE_MODES.ADD);
      }
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          lookupData={lookupData}
          fetchLookupData={fetchLookupData}
        />
      </div>
    </div>
  );
};

export default BenefitMaximumStepAlternateCopaysForm;